var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55494 18.3267L22.6854 33.4568C23.0353 33.8071 23.5025 34 24.0006 34C24.4987 34 24.9658 33.8071 25.3158 33.4568L26.43 32.3429C27.1551 31.617 27.1551 30.4372 26.43 29.7124L13.7246 17.0071L26.4441 4.28756C26.7941 3.93734 26.9873 3.47046 26.9873 2.97263C26.9873 2.47424 26.7941 2.00737 26.4441 1.65687L25.3299 0.543171C24.9797 0.192946 24.5128 5.63925e-06 24.0147 5.68279e-06C23.5166 5.72634e-06 23.0494 0.192946 22.6995 0.543171L7.55494 15.6871C7.20416 16.0385 7.0115 16.5076 7.0126 17.0062C7.0115 17.5068 7.20416 17.9756 7.55494 18.3267Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeft);
export default __webpack_public_path__ + "static/media/left.4e0b6a9a7ffe3564a5b7bbf73e5b06d9.svg";
export { ForwardRef as ReactComponent };